import { CONVERSATION_LIMIT_TIME_ZONE } from "../../supabase/functions/_shared/conversation-limit";
import { formatCount } from "@/lib/conversation-count";

export const LIMIT_REACHED_LABEL = "Llegaste a tu límite";

export function unattendedConversations(used: number | null | undefined, effectiveLimit: number | null | undefined): number {
  if (effectiveLimit === null || effectiveLimit === undefined || !(effectiveLimit > 0)) return 0;
  return Math.max(0, Math.floor(Number(used ?? 0) || 0) - effectiveLimit);
}

export function formatLimitReachedDate(value: string | null | undefined): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat("es-CO", {
    timeZone: CONVERSATION_LIMIT_TIME_ZONE,
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}

export function limitReachedSummary(unattended: number, limitExceededAt: string | null | undefined): string {
  if (!(unattended > 0)) return LIMIT_REACHED_LABEL;
  const noun = unattended === 1 ? "conversación" : "conversaciones";
  const since = formatLimitReachedDate(limitExceededAt);
  return `${LIMIT_REACHED_LABEL} · ${formatCount(unattended)} ${noun} sin atender${since ? ` desde ${since}` : ""}`;
}
